import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReCAPTCHA from "react-google-recaptcha";
import PropTypes from 'prop-types';

let captcha;

class Captcha extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        if(prevProps.reset !== this.props.reset) {
            this.resetCaptcha();
        }
    }

    setCaptchaRef = (ref) => {
        if (ref) {
        return captcha = ref;
        }
    };

    onChange = (value) => {
        this.props.submitData(value)
    }

    resetCaptcha = () => {
        captcha.reset();
      }

    getSiteKey = () => {
        const hostName = window.location.hostname;
        let key = '';
        switch (hostName) {
            case 'localhost': {
                key = "6LdH294ZAAAAAH9jTBLTtbm1YN7joCb1g30PMx6r";
                break;
            }
            case 'welsend.dev.ukrgasaws.com': {
                key = "6LdH294ZAAAAAH9jTBLTtbm1YN7joCb1g30PMx6r";
                break;
            }
            case 'welsend.ukrgasaws.com': {
                key = "6LcpF3AaAAAAAEmsqA70FXd-3q3dgcQ1sBm2DnoZ";
                break;
            }
            case 'welsend.com.ua': {
                key = "6LcWmbQaAAAAAJqTLB1q_b2fC3PezQ30TCbCLT4r";
                break;
            }
            default: {
                key = "6LcWmbQaAAAAAJqTLB1q_b2fC3PezQ30TCbCLT4r";
            }
        }
        return key;
    }

    render() {
        return(
            <div className="captcha">
                <ReCAPTCHA
                    ref={(r) => this.setCaptchaRef(r) }
                    sitekey={this.getSiteKey()}
                    onChange={this.onChange}
                    hl={this.props.activeLang ? this.props.activeLang : 'uk'}
                />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    activeLang: state.lang.activeLang
})

export default connect(mapStateToProps)(Captcha);

Captcha.propTypes = {
    submitData: PropTypes.func.isRequired,
    activeLang: PropTypes.string.isRequired,
    reset:  PropTypes.bool
}